module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.entity) ? _c('div', {
    staticClass: "component-invoice-action-buttons"
  }, [(_vm.item) ? _c('div', {
    staticClass: "dropdown-actions"
  }, [(_vm.item) ? _c('ul', {
    directives: [{
      name: "f",
      rawName: "v-f"
    }],
    staticClass: "dropdown menu",
    attrs: {
      "data-dropdown-menu": ""
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#Item-1"
    }
  }, [_vm._v("Action")]), _c('ul', {
    staticClass: "menu"
  }, [((_vm.entity.type === 'INVOICE' || _vm.entity.type === 'PROFORMA') && _vm.entity.status !== 'PAID') ? _c('li', [_c('invoice-reveal-pay', {
    attrs: {
      "invoice": _vm.entity
    },
    on: {
      "payInvoice": _vm.payInvoice
    }
  })], 1) : _vm._e(), (_vm.entity.type === 'INVOICE' && _vm.entity.status !== 'PAID') ? _c('li', [_c('invoice-reveal-mark-as-paid', {
    attrs: {
      "invoice": _vm.entity
    },
    on: {
      "setPaid": _vm.setPaid
    }
  })], 1) : _vm._e(), (_vm.entity.type === 'INVOICE' && _vm.entity.status !== 'CANCELED') ? _c('li', [_c('invoice-reveal-void', {
    attrs: {
      "invoice": _vm.entity
    }
  })], 1) : _vm._e(), (_vm.$isModuleEnabled('italian-e-invoice')) ? _c('li', [_c('button', {
    staticClass: "button",
    on: {
      "click": _vm.downloadXML
    }
  }, [_vm._v("Scarica fattura XML")])]) : _vm._e(), (_vm.$isModuleEnabled('zucchetti')) ? _c('li', [_c('DownloadAsEvilVersion', {
    attrs: {
      "invoice": _vm.entity
    }
  })], 1) : _vm._e(), (_vm.$isModuleEnabled('aruba-italian-e-invoice')) ? _c('li', [_c('UpdateEinvoiceFileName', {
    attrs: {
      "invoice": _vm.entity
    }
  })], 1) : _vm._e(), (_vm.$isModuleEnabled('aruba-italian-e-invoice')) ? _c('li', [_c('SendToExternal', {
    attrs: {
      "invoice": _vm.entity
    }
  })], 1) : _vm._e(), (_vm.$isModuleEnabled('aruba-italian-e-invoice')) ? _c('li', [_c('EinvoiceGetStatus', {
    attrs: {
      "invoice": _vm.entity
    }
  })], 1) : _vm._e(), _c('li', [_c('invoice-transactions', {
    attrs: {
      "invoice": _vm.entity
    }
  })], 1), (_vm.entity.type === 'PROFORMA') ? _c('li', [_c('ConvertProformaToCreditNote', {
    attrs: {
      "invoice": _vm.entity
    }
  })], 1) : _vm._e(), _c('li', [_c('ActionButton', {
    attrs: {
      "confirm": true,
      "action": _vm.markAsAwaitingPayment
    }
  }, [_vm._v("Mark as awaiting payment")])], 1)])])]) : _vm._e(), _c('button', {
    staticClass: "button small",
    on: {
      "click": function($event) {
        return _vm.openUrl(_vm.entity.url)
      }
    }
  }, [_vm._m(0)]), _c('is-module-enabled', {
    attrs: {
      "module": "italian-e-invoice"
    }
  }, [_c('button', {
    staticClass: "button small",
    on: {
      "click": _vm.downloadXML
    }
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-code"
  }), _vm._v("  Download XML")])]), (_vm.xmlUrl) ? _c('a', {
    attrs: {
      "href": _vm.xmlUrl
    }
  }) : _vm._e()])], 1) : _c('div', {
    staticClass: "dropdown-buttons"
  }, [((_vm.invoice.type === 'INVOICE' || _vm.entity.type === 'PROFORMA') && _vm.invoice.status !== 'PAID' && _vm.invoice.status !== 'CANCELED') ? _c('invoice-reveal-pay', {
    attrs: {
      "invoice": _vm.entity
    },
    on: {
      "payInvoice": _vm.payInvoice
    }
  }) : _vm._e(), (_vm.invoice.type === 'INVOICE' && _vm.invoice.status !== 'PAID' && _vm.invoice.status !== 'CANCELED') ? _c('invoice-reveal-mark-as-paid', {
    attrs: {
      "invoice": _vm.entity
    },
    on: {
      "setPaid": _vm.setPaid
    }
  }) : _vm._e(), (_vm.invoice.type === 'INVOICE' && _vm.invoice.status !== 'CANCELED') ? _c('invoice-reveal-void', {
    attrs: {
      "invoice": _vm.entity
    }
  }) : _vm._e(), (_vm.$isModuleEnabled('aruba-italian-e-invoice') && (_vm.invoice.type === 'INVOICE' || _vm.entity.type === 'CREDIT NOTE')) ? _c('EinvoiceGetStatus', {
    attrs: {
      "invoice": _vm.entity
    }
  }) : _vm._e(), (_vm.$isModuleEnabled('aruba-italian-e-invoice') && (_vm.invoice.type === 'INVOICE' || _vm.entity.type === 'CREDIT NOTE')) ? _c('SendToExternal', {
    attrs: {
      "invoice": _vm.entity
    }
  }) : _vm._e(), _c('ActionButton', {
    attrs: {
      "confirm": true,
      "action": _vm.markAsAwaitingPayment
    }
  }, [_vm._v("Mark as awaiting payment")]), _c('invoice-transactions', {
    attrs: {
      "invoice": _vm.entity
    }
  }), _c('is-module-enabled', {
    attrs: {
      "module": "zucchetti"
    }
  }, [_c('DownloadAsEvilVersion', {
    attrs: {
      "invoice": _vm.entity
    }
  })], 1), _c('invoice-records', {
    attrs: {
      "invoice": _vm.entity
    }
  })], 1)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-file-pdf-o"
  }), _vm._v("  Download")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-67c43870!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/actions/InvoiceButtons.vue
// module id = 2559
// module chunks = 1